export default __webpack_public_path__ + "static/media/FinishedConversationsGray.14af0457.svg";